import { useSyncExternalStore } from 'react';

const subscribe = () => () => {};

/**
 * Vrai uniquement après l'hydratation côté client.
 *
 * À utiliser pour différer le rendu de contenus dérivés de sources qui ne sont accessibles
 * qu'au client (localStorage, panier zustand persisté...) et provoqueraient sinon un flash
 * d'hydratation, le premier rendu serveur n'ayant jamais accès à ces sources.
 */
export function useIsClient(): boolean {
    return useSyncExternalStore(
        subscribe,
        () => true,
        () => false,
    );
}
